export const SITE = {
  name: 'Music24',
  url: 'https://music24.app',
  locale: 'en_US',
  twitter: '',
  defaultTitle: 'Music24 — Free Jewish Music Radio & Live Stream',
  defaultDescription:
    'Free Jewish music radio. Stream Yiddish, sefira, kumzitz, chazzanus, and new Jewish music live 24/6. No ads, no subscription.',
  defaultKeywords: [
    'jewish music',
    'jewish music radio',
    'jewish music stream',
    'jewish music streaming',
    'yiddish music',
    'yiddish radio',
    'sefira music',
    'sfirah music',
    'shabbos music',
    'new jewish music',
    'music streaming',
    'music24',
  ],
  ogImage: 'https://music24.app/og.png',
  ogImageWidth: 1200,
  ogImageHeight: 630,
} as const

export function absoluteUrl(path = '/'): string {
  if (path.startsWith('http')) return path
  const normalized = path.startsWith('/') ? path : `/${path}`
  return `${SITE.url}${normalized === '/' ? '' : normalized}`
}

export function titleFor(pageTitle?: string): string {
  if (!pageTitle) return SITE.defaultTitle
  if (pageTitle.includes('Music24')) return pageTitle
  return `${pageTitle} | Music24`
}
